import type { PropsWithChildren } from 'react';

import $ from './SkipLink.module.scss';

type SkipLinkProps = PropsWithChildren<{
  targetId: string;
}>;

function SkipLink({ targetId, children }: SkipLinkProps) {
  return (
    <a href={`#${targetId}`} className={$.skipLink}>
      {children}
    </a>
  );
}

export default SkipLink;
